import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import GlobalEvents from 'vue-global-events'

import Registration from './Registration'

import ApiMixins from '../../mixins/api'
import TrackingMixins from '../../mixins/tracking'
import allTranslation from '../../translation/all'
import storeConfig from './store'
import VueRouter from 'vue-router'
import './extension'

import StepOne from './views/StepOne'
import StepTwo from './views/StepTwo'
import StepThree from './views/StepThree'
import StepFinished from './views/StepFinished'
import RegistrationCodeStep from './views/RegistrationCodeStep'
import {
  getBrowserLanguage,
  isAgeRangeValid,
  isGenderValid,
  isSearchGenderValid,
  loadUtmParameter,
  removeQueryParameter
} from './util'

Vue.use(VueI18n)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueResource)

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: `${process.env.APP_VERSION}`,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  })
}
Vue.prototype.$sentry = Sentry

const router = () => new VueRouter({
  routes: [
    {
      path: '/',
      component: StepOne,
    }, {
      path: '/step-two',
      component: StepTwo,
    }, {
      path: '/step-three',
      component: StepThree,
    }, {
      path: '/email-validation',
      component: RegistrationCodeStep,
    }, {
      path: '/finish',
      component: StepFinished,
    }
  ]
})

const store = new Vuex.Store(storeConfig)

const i18n = new VueI18n({
  locale: 'de-DE',
  fallbackLocale: 'en',
  messages: allTranslation,
  silentFallbackWarn: true
})

// register common components global
Vue.component(GlobalEvents)
Vue.mixin(ApiMixins)
Vue.mixin(TrackingMixins)

window.registrationInit = (mountPointId, config = {}) => {
  const urlParams = new URLSearchParams(window.location.search)
  const couponId = urlParams.has('couponId') ? urlParams.get('couponId') : '';

  const utm = loadUtmParameter()
  removeQueryParameter()

  new Vue({
    router: router(),
    el: `#${mountPointId}`,
    store,
    i18n,
    beforeCreate () {
      const isSet = (propertyName) => {
        return config.hasOwnProperty(propertyName) && typeof config[propertyName] !== 'undefined'
      }

      if (isSet('promoter')) this.$store.commit('updatePromoter', config.promoter.toString())
      if (isSet('affiliate')) this.$store.commit('updateAffiliateId', config.affiliate.toString())
      if (isSet('legacyLogin')) this.$store.commit('updateLegacyLogin', config.legacyLogin)
      if (isSet('project')) this.$store.commit('updateProject', config.project)
      if (isSet('accessToken')) this.$store.commit('updateAccessToken', config.accessToken)
      if (isSet('showInCard')) this.$store.commit('updateShowInCard', config.showInCard)
      if (isSet('showTitle')) this.$store.commit('updateShowTitle', config.showTitle)
      if (isSet('titleText')) this.$store.commit('updateTitleText', config.titleText)
      if (isSet('buttonText')) this.$store.commit('updateButtonText', config.buttonText)
      if (isSet('testGroup')) this.$store.commit('updateTestGroup', config.testGroup)

      if (isSet('gender') && isGenderValid(config.gender)) {
        this.$store.commit('updateGender', config.gender)
      }

      if (isSet('searchGender') && isSearchGenderValid(config.searchGender)) {
        this.$store.commit('updateSearchGender', config.searchGender)
      }
      if (isSet('searchAgeRange') && isAgeRangeValid(config.searchAgeRange)) {
        this.$store.commit('updateSearchAgeRange', config.searchAgeRange)
      }

      this.$store.commit('updateCoupon', couponId)

      if (Object.keys(utm).length !== 0) this.$store.commit('updateUtm', utm)
    },
    mounted () {
      if (config.hasOwnProperty('accessToken') && !config.accessToken.isEmpty()) this.$router.push('finish')
    },
    render: h => h(Registration),
  })

  if (config.hasOwnProperty('language')) i18n.locale = config.language
  else i18n.locale = getBrowserLanguage()

  Vue.prototype.$dataLayer = window.dataLayer || []

  window.registrationIsOpen = () => {
    Vue.prototype.$dataLayer.push({
      'event': 'layeroeffnungen',
      'project': Vue.prototype.$project
    })
  }
}
